const rankingItems = [
  { id: 1, rank: 1, title: '某女星离婚内幕全面曝光：从婚变到财产分割', views: '526.8万', trend: 'up', hot: true },
  { id: 2, rank: 2, title: '知名导演被曝片场不当行为，多名演员联合指控', views: '489.3万', trend: 'up', hot: true },
  { id: 3, rank: 3, title: '某热门综艺嘉宾退出内幕揭秘，真实原因令人唏嘘', views: '412.6万', trend: 'up', hot: true },
  { id: 4, rank: 4, title: '带货一哥直播间翻车事件深度分析', views: '385.1万', trend: 'down', hot: false },
  { id: 5, rank: 5, title: '某歌手新歌被指抄袭，网友制作对比视频实锤', views: '358.7万', trend: 'up', hot: false },
  { id: 6, rank: 6, title: '某网红人设崩塌全记录：从巅峰到谷底', views: '312.4万', trend: 'down', hot: false },
  { id: 7, rank: 7, title: '某影视公司内部邮件泄露，签约内幕曝光', views: '298.9万', trend: 'up', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热度排行
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            实时更新的51黑料视频与吃瓜内容热度榜单
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 border-b border-background-200/70 last:border-b-0 transition-all hover:bg-background-50 cursor-pointer group"
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  {item.hot && (
                    <span className="text-[10px] bg-accent-500 text-background-50 px-1.5 py-0.5 rounded-full font-medium flex-shrink-0">
                      热
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-2 text-xs flex-shrink-0">
                <i
                  className={`${
                    item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'
                  }`}
                ></i>
                <span className="text-foreground-500">{item.views}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}